// Person samples are flat; Resource detail and frozen snapshots use nested fields.
export const normalizeSubmissionContributor = (person: any) => ({
  ...person,
  name: person.name || person.full_name || '',
  role: person.role ?? person.role_name,
  company:
    person.company ??
    (person.company_name
      ? {
          name: person.company_name,
          slug: person.company_slug,
        }
      : null),
});

export const contributorRoleLabel = (person: any): string => {
  const normalized = normalizeSubmissionContributor(person);
  return normalized.company?.name
    ? `${normalized.role || 'Works'} at ${normalized.company.name}`
    : normalized.role || '';
};
